import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MapPin, Phone, Mail, Clock, ChevronRight } from "lucide-react";
const serviceAreas = [{
  name: "Small Businesses",
  path: "/PricingPage"
}, {
  name: "Creative Portfolios",
  path: "/PricingPage"
}, {
  name: "E-commerce Stores",
  path: "/PricingPage"
}, {
  name: "Community Groups",
  path: "/PricingPage"
}, {
  name: "Personal Blogs",
  path: "/PricingPage"
}, {
  name: "SaaS Startups",
  path: "/PricingPage"
}, {
  name: "Local Boutiques",
  path: "/PricingPage"
}, {
  name: "Digital Agencies",
  path: "/PricingPage"
}];
export default function LocationAndServiceAreasRepairService() {
  return <section data-section-id="253404" id="footer" className="bg-secondary text-secondary-foreground flex flex-col border-t border-border">
      <div className="page-container py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block mb-2">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground font-default leading-relaxed">
              Webshingle: Modern AI WordPress for everyone. Build high-converting websites from a simple prompt in seconds.
            </p>
            <ul className="flex flex-col gap-4 mt-2">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground font-default">Global AI Infrastructure<br />Cloud Hosted Everywhere</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-primary shrink-0" />
                <Link to="/ContactSupportPage" className="text-muted-foreground hover:text-primary transition-colors font-default">
                  Contact Sales
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="/ContactSupportPage" className="text-muted-foreground hover:text-primary transition-colors font-default">
                  support@webshingle.com
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="size-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground font-default">24/7 AI Assistance<br />Human Support: Mon-Fri</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 text-foreground">Solutions</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4">
              {serviceAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to={area.path} className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5 group font-default">
                    <ChevronRight className="size-4 text-primary/50 group-hover:text-primary transition-colors" />
                    {area.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xl font-bold mb-6 text-foreground">Trust & Security</h3>
            <div className="rounded-lg overflow-hidden border border-white/10 shadow-lg bg-muted/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/webshingle_trust_signals.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/webshingle_trust_signals.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/webshingle_trust_signals.png-wvc-sizes" alt="SSL Secure and Powered by WordPress" className="w-full h-[240px] object-cover hover:scale-105 transition-transform duration-500" loading="lazy" />
            </div>
            <p className="text-sm text-muted-foreground mt-4 font-default">
              Enterprise-grade security with SSL, daily backups, and managed WordPress hosting included.
            </p>
          </div>

        </div>
      </div>

      {}
      <div className="bg-primary text-primary-foreground py-4">
        <div className="page-container text-center text-sm font-bold tracking-wider uppercase">
          Copyright 2026 © Webshingle. Built with AI for everyone.
        </div>
      </div>
    </section>;
}